import { Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NavigationService } from 'src/app/core/service/navigation.service';
import { scaleFadeIn400ms } from 'src/app/shared/animations/scale-fade-in.animation';
import { NavigationItem } from 'src/app/core/interface/navigation-item.interface';
import { LayoutService } from 'src/app/core/service/layout.service';
import { AuthService } from 'src/app/core/service/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { AccessService } from 'src/app/core/service/access.service';
import { SplashScreenService } from 'src/app/core/service/splash-screen.service';
import { environment as env } from '../../../../../environments/environment';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatBadgeModule } from '@angular/material/badge';
import { IconComponent } from 'src/app/shared/components/icon/icon.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SidenavItemComponent } from './components/sidenav-item/sidenav-item.component';
//import { NotificationsPopUpComponent } from 'src/app/core/notifications/components/notifications-pop-up/notifications-pop-up.component';
import { CommonModule } from '@angular/common';
import { MatSidenav } from '@angular/material/sidenav';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'mg-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: true,
  // imports: [MatBadgeModule, IconComponent, MatTooltipModule, SidenavItemComponent, MatMenuModule, NotificationsPopUpComponent, CommonModule],
  imports: [MatBadgeModule, IconComponent, MatTooltipModule, SidenavItemComponent, MatMenuModule, CommonModule],
  animations: [scaleFadeIn400ms],
})
export class SidenavComponent {
  @Input() collapsed!: boolean | null;
  @Input() isDesktop!: boolean | null; 
  @Output() toggleSidenav = new EventEmitter<boolean>();
  @ViewChild('menuTriggerNotifications') menuTriggerNotifications!: MatMenuTrigger;
  @Output() clickItem = new EventEmitter<boolean>(); 
  items: NavigationItem[];
  counterNotifications: number = 0;
  env = env;

  constructor(
    private _navigationService: NavigationService,
    private _authService: AuthService,
    private _accessService: AccessService,
    private _dialog: MatDialog,
    private _layoutService: LayoutService,
    private _splashScreenService: SplashScreenService,
    //private _notificationsService: NotificationsService,
  ) { 
    this.items = this._navigationService.items
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes["isDesktop"]["currentValue"]) {
    //   // this._notificationsService.countNotifications$.subscribe(x=> {
    //      //this.badgeCounterNotifications(x);
    //   // })
    // }
  }

  toggleCollapse() {
    this.collapsed
      ? this._layoutService.expandSidenav()
      : this._layoutService.collapseSidenav();
  }

  onToggleSidenav() {
    this.toggleSidenav.emit(!this.collapsed);
  }

  logout() {
      this._splashScreenService.show();
      this._authService.logout().subscribe({
        next: (resp) => {
            if(resp){
              this._accessService.removeAccess().subscribe(()=>{
                this._dialog.closeAll();
                window.location.href = 'auth/login';
              });
            }
        },
        error: e => {
          console.warn(e.error.message)
        }
      });

  }

  badgeCounterNotifications(counter: number){
    setTimeout(() => {
      this.counterNotifications = counter;
    },0)
  } 

  clickItemAction(e:boolean){
    this.clickItem.emit(e);
  }
}
